export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7851.688c1817.jpg";